import React from 'react';
import { Text } from '@admitkard/ccl/Text';
import { theme } from '@admitkard/ccl/style';
import { env } from '@admitkard/uiutils/env';

const HowToConnect = [{
  icon: env.getAssetUrl('images/sign-up.svg'),
  title: 'Sign Up',
  description: 'Make an Account in Seconds with Social Logins',
}, {
  icon: env.getAssetUrl('images/profile-completion.svg'),
  title: 'Complete your Profile',
  description: 'Fill up your basic Information and study preference',
}, {
  icon: env.getAssetUrl('images/connect-with-mentor.svg'),
  title: 'Connect with mentors',
  description: 'Choose and connect among the recommended mentors',
}];

export const StepsToConnect: React.FunctionComponent = () => (
  <>
    <ul className="connect-with-mentor__how-to-connect-listing">
      {(HowToConnect.map((data, index) =>
        <li key={`mentor-benefits-${index}`}>
          <div className="connect-with-mentor__how-to-connect-content">
            <Text
              variant='l'
              className=''
              display='block'
              weight='bold'>
              {data.title}
            </Text>
            <div className="connect-with-mentor__how-to-connect-icon">
              <img src={data.icon} alt={data.title} />
            </div>
            <Text
              variant='m'
              lightness={6}
              className='text-center'
              display='block'
              weight='normal'>
              {data.description}
            </Text>
          </div>
        </li>
      ))}
      <li className="connect-with-mentor__how-to-connect__empty-card"></li>
      <li className="connect-with-mentor__how-to-connect__empty-card"></li>
      <li className="connect-with-mentor__how-to-connect__empty-card"></li>
    </ul>
    <style>{`
      .text-center {
        text-align: center;
      }
      .connect-with-mentor__how-to-connect-listing {
        margin: ${theme.spacingOld(7)} 0;
        padding: 0;
        list-style: none;
        display: flex;
        flex-wrap: wrap;
      }
      .connect-with-mentor__how-to-connect-listing li {
        margin: ${theme.spacingOld(5)};
        background: ${theme.palette.grey[0]};
        padding: ${theme.spacingOld(6)};
        width: 33%;
        display: flex;
        flex-basis: 220px;
        flex-grow: 1;
        justify-content: center;
        text-align: center;
      }
      .connect-with-mentor__how-to-connect-listing li:nth-child(1) {
        margin-left: 0;
      }
      .connect-with-mentor__how-to-connect-listing li:nth-child(3) {
        margin-right: 0;
      }
      .connect-with-mentor__how-to-connect-icon {
        margin-bottom: ${theme.spacingOld(5)};
      }
      .connect-with-mentor__how-to-connect-icon img {
        height: 90px;
      }
      .connect-with-mentor__how-to-connect-content {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
      }
      .connect-with-mentor__how-to-connect-content span:nth-child(1) {
        margin-bottom: ${theme.spacingOld(5)};
        text-align: center;
      }
      li.connect-with-mentor__how-to-connect__empty-card {
        display: none;
      }
      @media screen and (max-width: 768px) {
        .connect-with-mentor__how-to-connect-listing li:nth-child(1) {
          margin-left: ${theme.spacingOld(5)};
        }
        .connect-with-mentor__how-to-connect-listing li:nth-child(3) {
          margin-right: ${theme.spacingOld(5)};
        }
        li.connect-with-mentor__how-to-connect__empty-card {
          margin: 0 ${theme.spacingOld(3)} 0;
          width: 33%;
          flex-basis: 220px;
          flex-grow: 1;
          padding: 0;
        }
      }
    `}</style>
  </>
);
